import { render, staticRenderFns } from "./UserPoolsCreateAccount.vue?vue&type=template&id=06cdc140&"
import script from "./UserPoolsCreateAccount.vue?vue&type=script&lang=js&"
export * from "./UserPoolsCreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports